import { defa, T }        from 'defa-object';
import { silverMapStyle } from 'scripts/defa/control/map/google-maps-silver-style';
import ControlModule      from 'scripts/poppet/control-module';
import template           from 'scripts/defa/control/map/controlFinder.jst.html';
import mapInfoboxTemplate from 'scripts/defa/control/map/mapInfoBox.jst.html';
import { Vue }            from 'vue/defavue';

/* global google */ // Loaded dynamically

/**
 * defa.views.ControlFinderView
 * to the 1.3.* - style of view! A view for viewing live position.
 * @version 1.2.1
 */


const selectors = {
	container        : '[data-container=finderMap-container]',
	buttonRefresh    : '[data-click=finderMap-refresh]',
	buttonToggle     : '[data-toggle=expand-spoiler]',
	buttonPositioning: '[data-input=positioning]'
};


const apiRoot = defa.vars.apiHost;
const api     = {
	latlong   : apiRoot + '/units/%s/gpslatest',
	googlemaps: 'https://maps.googleapis.com/maps/api/js?key=' + $defaConfig.googleMapsCode,
};

let vueElement = '';

const sliderOptions = [
	{ value: 'ON', title: T.tc( 'Security', 'On' ), titleContext: 'FinderSetting' },
	{ value: 'OFF', title: T.tc( 'Security', 'Off' ), titleContext: 'FinderSetting' }
];

const ControlFinderView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	mapInitialized: false,
	
	template          : template,
	className         : function () {
		return this._getClassName( 'control-finder' );
	},
	expandedNavState  : 'unit:control:finder',
	compressedNavState: 'unit:control:overview',
	
	ui: {
		container   : selectors.container,
		refresh     : selectors.buttonRefresh,
		toggle      : selectors.buttonToggle,
		positioning : selectors.buttonPositioning
	},
	
	events: {
		'click @ui.toggle' : 'onClickToggle',
		'click @ui.devices': 'onClickDevices',
		'click @ui.refresh': 'onClickRefresh',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	/**
	 * Triggers when the view renders.
	 * @void
	 */
	onRender: function () {

	},
	
	/**
	 * Triggers when the refresh button is clicked.
	 * @void
	 */
	onClickRefresh: function () {
		this.fetch();
	}
	,
	/**
	 * Triggers when the toggle is clicked and the module is expanded.
	 * @void
	 */
	onClickToggle: function ( event ) {
		ControlModule.prototype.onClickToggle.call( this, event );
		if (this.ui.toggle.hasClass( 'open' ) ) {
			this.lazyInitMap();
		}
	},
	
	
	/**
	 * Triggers when model is completed. This happens the first time a unit is opened or if the page is reloaded.
	 * @void
	 */
	afterModelComplete: function(){
		if ( this._isOpen() ) {
			this.lazyInitMap();
		}
	},
	
	onDomRefresh: function () {
		let self = this;
		vueElement = new Vue( {
			el: '#finder-vue',
			bb() {
				return {
					model: self.model,
				}
			},
			data() {
				return {
					sliderValue: 'ON',
					sliderOptions,
				}
			},
			methods: {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= 'ON' === newValue ? true: false;
					self.save( data )
				},
			},
			watch: {
				'model.finderActivated': function (newAttribute){
					this.sliderValue = newAttribute ? 'ON' : 'OFF';
					console.log(newAttribute);
				}
			},
			
			created() {
				this.sliderValue = this.model.finderActivated ? 'ON' : 'OFF';
			}
		} );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	showRefreshButton: function(){
		if(this.ui.refresh.hasClass('hidden')){
			this.ui.refresh.removeClass('hidden')
		}
	},
	
	hideRefreshButton: function(){
		if(!this.ui.refresh.hasClass('hidden')){
			this.ui.refresh.addClass('hidden')
		}
	},
	/**
	 * Initializes the map
	 * @void
	 */
	lazyInitMap: function () {
		if ( !this.mapInitialized) {
			installRobotoFontHack();
			
			this.busy();
			if ( !window.google ) {
				this.getMaps();
			}
			this.mapInitialized = true;
		}else {
			this.showFinder();
		}
	},
	
	/**
	 * Fetches GoogleMaps
	 * @void
	 */
	getMaps: function () {
		$.getScript( api.googlemaps )
		 .done( () => {
			 this.showFinder();
		 } );
	},
	
	/**
	 * Adds and draws the map.
	 * @void
	 */
	showMap: function(){
		let locationGPS = this.model.getLocation();
		this.showRefreshButton();
		if ( !this.map ) {
			this.drawMap( locationGPS );
		}
		this.drawMarker( {
			locationGPS,
			time    : this.model.getTime(),
			heading : this.model.getDirection(),
			speed   : this.model.getSpeed(),
			accuracy: this.model.getAccuracy()
		} );
		this.idle();
	},
	
	/**
	 * Adds an error message based on what is retrieved from backend.
	 * @void
	 */
	showModelNotCompleteError: function(){
		this.hideRefreshButton();
		this.map = null;
		if ( !this.model.get('hasGps') ) {
			this.ui.container.html( '<p class="error">' + T.tc( 'UnitMap', 'The unit does not have a gps connected.' ) + '</p>' );
			this.idle();
		} else if ( !this.model.isLocationRetrieved() ) {
			this.ui.container.html( '<p class="error">' + T.tc( 'UnitMap', 'Could not retrieve position, try refreshing or reloading the page.' ) + '</p>' );
			this.idle();
		}else{
			this.ui.container.html( '<p class="error">' + T.tc( 'UnitMap', 'Something went wrong, try refreshing or reloading the page.' ) + '</p>' );
			this.idle();
		}

	},
	
	/**
	 * Adds an error message if the user tries view the map without having positioning activated.
	 * @void
	 */
	showGpsNotActivatedError: function(){
		this.hideRefreshButton();
		this.map = null;
		this.ui.container.html( '<p class="error">' + T.tc( 'UnitMap', 'Positioning must be enabled to use this feature.' ) + '</p>' );
		this.idle();
	},
	
	/**
	 * Adds the map or an error message based on whether or not gps i activated.
	 * @void
	 */
	showFinder: function () {
		if(!this.model.get( 'finderActivated' )){
			this.showGpsNotActivatedError();
		}else{
			if ( this.model.get( 'finderActivated' ) && this.mapInitialized && this.model.isEntireModelRetrieved() ) {
				this.showMap();
			} else if ( this.model.get( 'finderActivated' ) && !this.model.isEntireModelRetrieved() ) {
				this.showModelNotCompleteError();
			}
		}
	},
	
	/**
	 * Draws the map to the view.
	 * @void
	 */
	drawMap: function ( locationGPS ) {
		// set element height.
		if ( $( window ).outerWidth() < 700 ) {
			this.ui.container.css( 'height', 'calc(100vh - 275px)' );
		} else {
			this.ui.container.css( 'height', 'calc(100vh - 275px)' );
		}
		
		this.map = new google.maps.Map( this.ui.container.get( 0 ), {
			zoom          : 14,
			animation     : google.maps.Animation.DROP,
			center        : locationGPS,
			mapTypeControl: true,
			styles        : silverMapStyle
		} );
		
	},
	
	/**
	 * Draws the marker on the map.
	 * @void
	 */
	drawMarker: function ( { locationGPS, time, heading, ignition, speed, accuracy } ) {
		console.log( 'drawMarker', locationGPS );
		// clear marker
		if ( this.marker ) {
			this.marker.setMap( null );
		}
		if ( this.circle ) {
			this.circle.setMap( null );
		}
		
		// draw marker
		const marker = new google.maps.Marker( {
			position : locationGPS,
			animation: google.maps.Animation.DROP,
			map      : this.map,
		} );
		
		const circle = new google.maps.Circle( {
			fillColor   : '#4392ff',
			fillOpacity : 0.35,
			strokeWeight: 0,
			map         : this.map,
			center      : locationGPS,
			radius      : accuracy
		} );
		
		let alias        = this.options.unit.get( 'alias' );
		const infoWindow = new google.maps.InfoWindow( {
			content: mapInfoboxTemplate( { locationGPS, time, alias, heading, ignition, speed } )
		} );
		marker.addListener( 'click', () => {
			infoWindow.open( this.map, marker );
		} );
		
		this.marker = marker;
		this.circle = circle;
		this.map.panTo( locationGPS );
	},
	
	/**
	 * Saves the model to backend.
	 * @void
	 */
	save: function( attributes ) {
		let self = this;
		self.model.set('isValidData', false);
		try {
			this.model.save(attributes,{
				isSaving: true,
				patch: true,
				success: function() {
					if(self.model.get('finderActivated') && null === self.model.get('finderActivatedError')){
						self.fetch();
					}else{
						self.showFinder();
					}
				},
				error: function(model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	/**
	 * Fetches the model from backend.
	 * @void
	 */
	fetch: function(){
		let self = this;
		self.model.set('isValidData', false);
		try {
			self.model.fetch ({
				success: function(model, response, options) {
					console.log('Model was Fetched!: ' + JSON.stringify(self.model));
					self.lazyInitMap();
					
				},
				error: function() {
					alert( 'failed syncing' );
					console.error( 'Model failed at fetching...' );
				}
			});
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
} );


function installRobotoFontHack() {
	const isRoboto     = ( element ) => element.href && element.href.indexOf( 'css?family=Roboto' ) !== -1;
	const head         = $( 'head' )[ 0 ];
	const insertBefore = head.insertBefore;
	head.insertBefore  = ( newElement, refElement ) => {
		if ( isRoboto( newElement ) ) {
			console.log( 'suppressed Roboto' );
			return;
		}
		insertBefore.call( head, newElement, refElement );
	};
	const appendChild  = head.appendChild;
	head.appendChild   = ( element ) => {
		if ( isRoboto( element ) ) {
			console.log( 'suppressed Roboto' );
			return;
		}
		appendChild.call( head, element );
	};
}




export default ControlFinderView;
